import { PublicKey } from "@solana/web3.js";

/**
 * Derive the `game_state` PDA
 */
export function deriveGameStatePda(
  programId: PublicKey,
  adminPubkey: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from("game-state4"),
      adminPubkey.toBuffer(),
    ],
    programId
  );
}

/**
 * Derive the `game_state_authority` PDA
 */
export function findGameStateAuthorityPda(
  programId: PublicKey,
  gameStatePubkey: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from("game-state-authority4"),
      gameStatePubkey.toBuffer(),
    ],
    programId
  );
}

/**
 * Derive the `roll_income` PDA
 */
export function findRollIncomePda(
  programId: PublicKey,
  gameStatePubkey: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from("roll-income"),
      gameStatePubkey.toBuffer(),
    ],
    programId
  );
}

/**
 * Derive the `reward_pool` PDA
 */
export function findRewardPoolPda(
  programId: PublicKey,
  gameStatePubkey: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from("reward-pool"),
      gameStatePubkey.toBuffer(),
    ],
    programId
  );
}

export function derivePlayerStatePda(
  programId: PublicKey,
  playerPubkey: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from("player-state5"),
      playerPubkey.toBuffer(),
    ],
    programId
  );
}

